const IGNORED_EXCEPTION_TYPES = ['ApolloError'];

const IGNORED_EXCEPTION_PATTERNS = [
  /Loading chunk [\d]+ failed/,
  /Network request (failed|timed out)/,
  /Failed to fetch dynamically imported module/,
  /Importing a module script failed/,
  /NetworkError when attempting to fetch resource/,
  /^(?:(?:Type|Apollo)Error: )?(?:Failed to fetch|Load failed)$/,
  /messaging\/(?:unknown|unsupported-browser|permission-blocked)/,
  /ResizeObserver loop/,
  /Object Not Found Matching Id:\d+, MethodName:update/,
  /SERVICE_NOT_AVAILABLE/,
  /The Internet connection appears to be offline/,
];

export type AnalyticsEventLike = {
  event: string;
  properties?: Record<string, unknown>;
};

const firstException = (event: AnalyticsEventLike) => {
  const exceptions = event.properties?.['$exception_list'];
  const first: unknown = Array.isArray(exceptions) ? exceptions[0] : undefined;
  if (typeof first !== 'object' || first === null) {
    return {type: '', value: ''};
  }
  const type =
    'type' in first && typeof first.type === 'string' ? first.type : '';
  const value =
    'value' in first && typeof first.value === 'string' ? first.value : '';
  return {type, value};
};

export const isIgnoredException = (event: AnalyticsEventLike) => {
  if (event.event !== '$exception') {
    return false;
  }
  const {type, value} = firstException(event);
  if (IGNORED_EXCEPTION_TYPES.includes(type)) {
    return true;
  }
  const message = type ? `${type}: ${value}` : value;
  return IGNORED_EXCEPTION_PATTERNS.some(
    pattern => pattern.test(value) || pattern.test(message),
  );
};
